// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  transition-property: opacity;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
  opacity: 1;
}

.custom-modal-container {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 100%;
  transform: scale(1);
  transition-property: transform;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
}

.custom-modal-header {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 12px;
  height: 32px;
  box-sizing: border-box;
  background-color: var(--surface-primary);
  flex-shrink: 0;
}

.custom-modal-close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition-property: color, background-color;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-modal-close-button:hover {
  color: #4b5563;
  /* A darker gray on hover */
  background-color: #e5e7eb;
  /* A light gray background on hover */
}

.custom-modal-close-button:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px #6366f1;
  /* white and indigo rings */
}

.custom-modal-content {
  box-sizing: border-box;
  flex: 1;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,0BAA0B;EAC1B,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,4CAA4C;EAC5C,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB;;qBAEmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB","sourcesContent":[".custom-modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n  transition-property: opacity;\n  transition-duration: 300ms;\n  transition-timing-function: ease-in-out;\n  opacity: 1;\n}\n\n.custom-modal-container {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  transform: scale(1);\n  transition-property: transform;\n  transition-duration: 300ms;\n  transition-timing-function: ease-in-out;\n}\n\n.custom-modal-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  padding: 12px;\n  height: 32px;\n  box-sizing: border-box;\n  background-color: var(--surface-primary);\n  flex-shrink: 0;\n}\n\n.custom-modal-close-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition-property: color, background-color;\n  transition-duration: 200ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.custom-modal-close-button:hover {\n  color: #4b5563;\n  /* A darker gray on hover */\n  background-color: #e5e7eb;\n  /* A light gray background on hover */\n}\n\n.custom-modal-close-button:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  box-shadow:\n    0 0 0 2px #ffffff,\n    0 0 0 4px #6366f1;\n  /* white and indigo rings */\n}\n\n.custom-modal-content {\n  box-sizing: border-box;\n  flex: 1;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
